import React from 'react'
import Navbar from './Navbar'

const index = () =><Navbar/>

export default index